/* eslint-disable no-nested-ternary */
import React from 'react';
import { Star, StarO, StarHalfO } from '@crehana/icons';
import { yellowLight } from '@crehana/ui/dist/styles/colors';

import type { CourseCardProps } from '../../types';

const RatingStar = ({ index, average }: { index: number; average: number }) => {
  if (average === 0) {
    return <StarO key={index} size={12} color={yellowLight} />;
  }

  if (index < Math.floor(average)) {
    return <Star size={12} color={yellowLight} />;
  }

  const delta = average - index;

  if (delta <= 0.5) {
    return <StarHalfO key={index} size={12} color={yellowLight} />;
  }
  if (delta <= 0.99) {
    return <Star key={index} size={12} color={yellowLight} />;
  }

  return <StarO key={index} size={12} color={yellowLight} />;
};

const Rating: React.FC<Partial<CourseCardProps>> = props => {
  const { score } = props;

  if (!score) {
    return null;
  }

  return (
    <div className="flex items-center relative">
      {Array.from({ length: 5 }).map((_, i) => (
        <RatingStar key={i} index={i} average={score.average} />
      ))}
      <p className="font-caption text-base-main ml-4">{score.average}</p>
    </div>
  );
};

export default Rating;
